export interface Module {
  number: number
  title: string
  body: string
  tagline: string
  color: string
}

export const modules: Module[] = [
  {
    number: 1,
    title: 'EV & HYBRID SYSTEMS FUNDAMENTALS',
    body: 'Understand how modern electric, hybrid and plug-in hybrid vehicles operate before diagnosing them. Explore HEV, PHEV and BEV architectures, energy flow, high-voltage and low-voltage systems, contactors, interlocks, control modules and essential system relationships.',
    tagline: 'Understand. Connect. Diagnose.',
    color: '#2E7D46',
  },
  {
    number: 2,
    title: 'HIGH-VOLTAGE BATTERY & BMS DIAGNOSTICS',
    body: 'Understand battery packs, modules, monitoring systems and the diagnostic information provided by the BMS. Review battery temperatures, voltage relationships, state of charge, contactors, pre-charge systems, common symptoms and structured battery diagnostic paths.',
    tagline: 'Monitor. Compare. Diagnose.',
    color: '#1B6CA8',
  },
  {
    number: 3,
    title: 'ELECTRIC MOTOR, INVERTER & DRIVE SYSTEM DIAGNOSTICS',
    body: 'Follow the power path from the high-voltage battery through the inverter and electric drive system. Understand traction motors, inverters, motor-generators, position sensing, regenerative braking, drive-system warnings and propulsion-related fault patterns.',
    tagline: 'Follow. Test. Isolate.',
    color: '#E1701A',
  },
  {
    number: 4,
    title: 'CHARGING, DC-DC & LOW-VOLTAGE SYSTEM DIAGNOSTICS',
    body: 'Understand the systems responsible for charging and electrical power distribution. Work through charging faults, onboard chargers, DC-DC converters, 12V systems, charge-port conditions, communication problems and common charging symptoms.',
    tagline: 'Connect. Check. Diagnose.',
    color: '#C0392B',
  },
  {
    number: 5,
    title: 'THERMAL MANAGEMENT & SUPPORT SYSTEM DIAGNOSTICS',
    body: 'Understand how temperature control affects batteries, motors, inverters, charging and vehicle performance. Review battery cooling, pumps, valves, sensors, electric compressors, heat pumps, coolant circuits and common thermal-management fault patterns.',
    tagline: 'Monitor. Control. Protect.',
    color: '#6B3FA0',
  },
  {
    number: 6,
    title: 'EV & HYBRID FAULT-FINDING MASTER SYSTEM',
    body: 'Bring symptoms, warning messages, DTCs and scan data together into one structured diagnostic process. Work through No READY conditions, reduced propulsion, charging problems, battery warnings, thermal faults, communication issues and intermittent symptoms.',
    tagline: 'Observe. Isolate. Diagnose.',
    color: '#26313A',
  },
]

export interface Bonus {
  number: number
  title: string
  subtitle: string
  body: string
  tagline: string
}

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'EV & HYBRID QUICK DIAGNOSTIC REFERENCE™',
    subtitle: 'Workshop Symptom, System & Diagnostic Direction Guide',
    body: 'Start with the vehicle symptom or warning and quickly identify the systems, information and diagnostic direction that should be considered next.',
    tagline: 'Identify. Review. Follow.',
  },
  {
    number: 2,
    title: 'EV & HYBRID SCAN DATA INTERPRETATION GUIDE™',
    subtitle: 'Practical Reference for Reading Diagnostic Data With Context',
    body: 'Organize and interpret battery, motor, inverter, charging, thermal and low-voltage scan data without relying on isolated readings or assumptions.',
    tagline: 'Read. Compare. Interpret.',
  },
  {
    number: 3,
    title: 'EV & HYBRID DTC DECISION GUIDE™',
    subtitle: 'Turn Trouble Codes Into a Clearer Diagnostic Direction',
    body: 'Use DTCs, freeze-frame information and related system data to organize fault codes, recognize relationships and determine the next diagnostic direction.',
    tagline: 'Record. Connect. Diagnose.',
  },
  {
    number: 4,
    title: 'EV & HYBRID CUSTOMER COMPLAINT TO DIAGNOSTIC WORKSHEET PACK™',
    subtitle: 'Ready-to-Use Workshop Forms for Organized Fault-Finding',
    body: 'Document customer complaints, scan results, live data, charging problems, intermittent faults, diagnostic decisions and post-repair verification with structured worksheets.',
    tagline: 'Document. Organize. Verify.',
  },
  {
    number: 5,
    title: 'EV & HYBRID COMPONENT IDENTIFICATION & SYSTEM RELATIONSHIP GUIDE™',
    subtitle: 'Know the Component, Understand Its Role, Follow Its Connections',
    body: 'Identify major EV and hybrid components, understand their functions and see how battery, drive, charging, thermal and control systems interact.',
    tagline: 'Identify. Understand. Connect.',
  },
]
